export const CANCEL_SEARCH = 'evtbus:cancel-search'
